// src/pages/Unauthorized.js
import React from 'react';

const Unauthorized = () => {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>403 - Unauthorized</h2>
      <p>You do not have permission to access this page.</p>
    </div>
  );
};

export default Unauthorized;
